import UsersContainer from './users-container';

export default UsersContainer;
